import { gql } from '@apollo/client';

/**
 * Query to get all expenses for a work order
 */
export const GET_WORK_ORDER_EXPENSES = gql`
  query GetWorkOrderExpenses($workOrderId: ID!) {
    workOrderExpenses(workOrderId: $workOrderId) {
      id
      workOrderId
      title
      baseCost
      billedAmount
      createdAt
      updatedAt
      createdBy {
        id
        name
        firstName
        lastName
      }
    }
  }
`;

/**
 * Query to get calculated totals for work order expenses
 */
export const GET_WORK_ORDER_EXPENSE_TOTALS = gql`
  query GetWorkOrderExpenseTotals($workOrderId: ID!) {
    workOrderExpenseTotals(workOrderId: $workOrderId) {
      totalBaseCost
      totalBilledAmount
      totalProfit
      count
    }
  }
`;

/**
 * Query to get a single expense by ID
 */
export const GET_WORK_ORDER_EXPENSE = gql`
  query GetWorkOrderExpense($id: ID!) {
    workOrderExpense(id: $id) {
      id
      workOrderId
      title
      baseCost
      billedAmount
      createdAt
      updatedAt
      createdBy {
        id
        name
        firstName
        lastName
      }
      workOrder {
        id
        description
        status
      }
    }
  }
`;

